export const CHANGE_LOCATION = `@@router/LOCATION_CHANGE`;
export const LOAD_DATA = `LOAD_DATA`;

export const START = `_START`;
export const SUCCESS = `_SUCCESS`;
export const FAIL = `_FAIL`;
